import { IDepartmentData } from '@/models';
import { IDepartment } from '../department';

// API Data
export interface IGLAccountData {
  id?: number;
  code: string;
  name: string;
  departments: (IDepartmentData | number)[];
}

// Business Logic Interface
export interface IGLAccount extends IGLAccountData {
  departments: (IDepartment | number)[];

  validate(): boolean;
}

// Constants - Used for validation
export const GL_ACCOUNT_MAX_CODE_LENGTH = 6;
export const GL_ACCOUNT_MAX_NAME_LENGTH = 32;
